module.exports = __webpack_public_path__ + "img/memberCenterBgImage.ea97f0c1.jpeg";